import { environment } from 'src/environments/environment';

export class SheetLogoPrintData {

  private _data: any;
  private _svg: string;
  private _base64: any;

  constructor(data: any = null) {
    if (data) {
      this.data = data;

      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        this._svg = xhr.response;

        var img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = environment.ASSETS_SERVER+environment.LOGO.PDF_PRINT_LOGO;
        img.onload = () => {
          var canvas = <HTMLCanvasElement>document.createElement('canvas');
          var context = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0);
          this._base64 = canvas.toDataURL();
        };

      };

      xhr.open('GET', environment.ASSETS_SERVER+environment.LOGO.PDF_PRINT_LOGO);
      xhr.send();
    }
  }

  /**
	 * data
	 */
  public set data(value: any) {
    this._data = value;
  }

  public get x(): number {
    return +this._data.x;
  }

  public get y(): number {
    return +this._data.y;
  }

  public get width(): number {
    return +this._data.width;
  }

  public get height(): number {
    return +this._data.height;
  }

  public get rotation(): number {
    return +this._data.rotation;
  }

  public get svg(): string {
    return this._svg;
  }

  public get base64(): any {
    return this._base64;
  }

  /**
   * Cleanup
   */
  public cleanup(): void {
    this._data = null;
  }

}
